import { Action, Dispatch } from "redux";
import * as constants from "./constants";
import { IState, IDataEntity } from "../models";
import { Actions } from "./models";

export function toggleModal(shareClass?: IDataEntity) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let currentState = getState();
		let responseAction: Actions = {
			type: constants.TOGGLE_HISTORICAL_PRICES_MODAL,
			payload: {
				shareClass: shareClass,
				showModal: !currentState.modals.showModal
			}
		};
		dispatch(responseAction);
	};

}


// WEBPACK FOOTER //
// ./src/client/actions/modals.ts